export default [

     {
          path: '/threat-group',
          name: 'ThreatGroup',
          component: () => import("@/views/Page/ThreatGroup/ThreatGroup.vue"),
           meta: {
               title: 'Threat Group',
          },
     }
];